import { render, staticRenderFns } from "./standardLeftAside.vue?vue&type=template&id=36b4b5b5&scoped=true"
import script from "./standardLeftAside.vue?vue&type=script&lang=js"
export * from "./standardLeftAside.vue?vue&type=script&lang=js"
import style0 from "../scss/newStandard.scss?vue&type=style&index=0&id=36b4b5b5&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b4b5b5",
  null
  
)

export default component.exports